export default __webpack_public_path__ + "static/media/back-design.8e7e3c18.svg";